import { createApp } from 'vue'
import ExchangeReport from "@/components/ExchangeReport.vue"
import ImportReport from "@/components/ImportReport.vue"
import ExchangeSettings from "@/components/ExchangeSettings.vue"
import Documentation from "@/components/Documentation.vue";
import Quasar from 'quasar/src/vue-plugin.js';
import quasarUserOptions from './quasar-user-options'


createApp(ExchangeReport).use(Quasar, quasarUserOptions).use(Quasar, quasarUserOptions).mount('#exchangeReport')
createApp(ImportReport).use(Quasar, quasarUserOptions).use(Quasar, quasarUserOptions).mount('#importReport')
createApp(ExchangeSettings).use(Quasar, quasarUserOptions).use(Quasar, quasarUserOptions).mount('#exchangeSettings')
createApp(Documentation).use(Quasar, quasarUserOptions).use(Quasar, quasarUserOptions).mount('#APIDocumentation')